import {Injectable, OnDestroy} from '@angular/core';
import {BehaviorSubject, Subject} from 'rxjs';
import {TorchUserService} from '../../../@backend/modules';
import {
  TorchUnitTrackingService,
  TrackedUnitsChangedListener
} from '../../../@backend/modules';
import {distinctUntilChanged, share, takeUntil} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TorchNavigationService implements OnDestroy, TrackedUnitsChangedListener {
  private readonly unsubscribeAll: Subject<any>;
  private totalTrackedUnits: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  private lastValue: any;
  private badgeUpdatedListeners: TorchBadgeUpdatedListener[] = [];

  constructor(private torchUserService: TorchUserService, private unitTrackingService: TorchUnitTrackingService) {

    this.unsubscribeAll = new Subject();
    this.unitTrackingService.addListener(this);
  }

  public setupListeners() {
    this.getTrackedUnits();

    this.totalTrackedUnits.pipe(
      distinctUntilChanged()
    ).subscribe(total => this.updateTrackedUnitsItem(total));
  }

  ngOnDestroy() {
    this.unsubscribeAll.next(true);
    this.unsubscribeAll.complete();
  }

  public addBadgeUpdatedListener(listener: TorchBadgeUpdatedListener) {
    if (!this.badgeUpdatedListeners.includes(listener)) {
      this.badgeUpdatedListeners.push(listener);
    }
  }

  unitsChanged() {
    this.getTrackedUnits();
  }

  private getTrackedUnits() {
    this.unitTrackingService.getTotalTrackedUnits().pipe(
      takeUntil(this.unsubscribeAll),
      distinctUntilChanged(),
      share()
    ).subscribe(totalTrackedUnits => {
      this.totalTrackedUnits.next(totalTrackedUnits);
    });
  }

  private updateTrackedUnitsItem(newValue: number) {
    if (this.lastValue !== newValue) {
      this.lastValue = newValue;

      this.badgeUpdatedListeners.forEach(listener => {
        listener.badgeUpdated('tracker', newValue, true);
      });
    }
  }

}

export interface TorchBadgeUpdatedListener {
  badgeUpdated(id: string, value: number | string, favicon: boolean);
}
